module.exports = __webpack_public_path__ + "static/img/11.1844598.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/3/99/zh/11.png
// module id = jDL+
// module chunks = 0